var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttonHolder fRow aCenter jCenter"},[_c('i',{staticClass:"material-icons-round"},[_vm._v(_vm._s(_vm.icon))]),_c('input',{attrs:{"value":_vm.label,"type":"button"}})])}
var staticRenderFns = []

export { render, staticRenderFns }